<template>
  <div id="app">
      <loading :active.sync="system.appLoading"
               :can-cancel="false"
               loader="dots"
               color="#6d0606"
               :is-full-page="true"></loading>
      <transition name="fade" mode="out-in">
        <app-layout v-if="layout === 'default-layout'"></app-layout>
        <auth-layout v-if="layout === 'auth-layout'"></auth-layout>
      </transition>
      <v-tour name="myTour" :steps="steps"></v-tour>
  </div>
</template>

<script>
  import AppLayout from "./views/template/layouts/AppLayout";
  import AuthLayout from  './views/template/layouts/AuthLayout'
  import {mapState} from 'vuex'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';

  const default_layout = "default";

  export default {
    components:{
      AppLayout,
      AuthLayout,
      Loading
    },
    data() {
      return {
        //isLoading: false,
          steps: [
              {
                  target: '#v-step-0',  // We're using document.querySelector() under the hood
                  header: {
                      title: 'Get Started',
                  },
                  content: `Welcome to your <strong>Dashboard</strong>. Here you can monitor the activity and status of your account !`,
                  params: {
                      placement: 'left' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                  }
              },
              {
                  target: '#v-step-1',
                  header: {
                      title: 'Details',
                  },
                  content: 'Here you can view all the details about your company',
                  params: {
                      placement: 'left' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                  }
              },
              {
                  target: '#officer',
                  header: {
                      title: 'Officers',
                  },
                  content: 'Assign account role. The roles include signatory, Director, Developer or customer service. (Note that Developer and Customer service have limited access to this account)',
                  params: {
                      placement: 'left' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                  }
              },
              {
                  target: '#document',
                  header: {
                      title: 'Documents',
                  },
                  content: 'kindly provide required company documents. Documents provided will be accessed and verified by Rubies team.',
                  params: {
                      placement: 'left' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                  }
              },
              {
                  target: '#createuser',
                  header: {
                      title: 'Create User',
                  },
                  content: 'Creating a user will give access to Initiating transactions (bulk and single), view balance, generate account statement and more.',
                  params: {
                      placement: 'left' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                  }
              }
          ]
      }
    },
    computed: {
      ...mapState([
        'system',
        'officer',
        'company',
        'setting',
        'auth'
      ]),
      layout() {
        return (this.$route.meta.layout || default_layout) + '-layout';
      },
      model:{
        get(){
            console.log(this.officerFilteredByUserId(this.system.userInfo.id)[0])
            return this.officerFilteredByUserId(this.system.userInfo.id)[0]
        },
        set(){

        }
      }
    },
    methods:{
      async readCompaniesNAccount(){
        await this.$store.dispatch('system/updateUserInfo',{payload:"you"},{root:false})
        if(this.system.userInfo != null) await this.$store.dispatch("company/updateCompanies", {
          userID: this.system.userInfo.id,
          requestType: 'company'
        }, { root: false })
      },
      async readOfficers(){
        await this.$store.dispatch("officer/updateOfficers", {
          orgID: localStorage.orgID,
          accID: localStorage.accID,
          requestType: 'officer'
        }, {root: true})
      },
      officerFilteredByUserId(_item) {
        return this.officer.officers.filter(function (el) {
            return el.officerUserID == _item;
        });
      },
      async initDashboard(){
        if (this.$route.path !== '/officer-reg-complete' &&
            this.$route.path !== '/logon' &&
            this.$route.path !== '/forgot-password' &&
            this.$route.path !== '/register') {
            //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>calling')
            while (this.system.userInfo == null)
                await this.$store.dispatch("system/updateUserInfo", {payload: "you"}, {root: false});
            // if (this.system.userInfo != null)
            await this.$store.dispatch("company/updateCompanies", {
                userID: this.system.userInfo.id,
                requestType: 'company'
            }, {root: false});
            // else this.$router.push('/');
            if (this.company.companies.length > 0) await this.$store.dispatch("system/updateDashboard", {
                orgID: localStorage.orgID,
                userID: this.system.userInfo.id,
                accID: localStorage.accID,
                requestType: 'dashboard'
            }, {root: true});
            if (this.company.companies.length > 0) await this.$store.dispatch("officer/updateOfficers", {
                orgID: localStorage.orgID,
                accID: localStorage.accID,
                requestType: 'officer'
            }, {root: true});
            //console.log(this.company.account[0]);
            if (this.company.companies.length > 0) this.$store.dispatch("logs/readFtLogs", {
                customerId: this.company.account[0].accCustID
            }, {root: true});
            if (this.company.companies.length > 0) this.$store.dispatch("logs/readNeLogs", {
                customerId: this.company.account[0].accCustID
            }, {root: true});
            if (this.company.companies.length > 0) await this.$store.dispatch("setting/getApiKey", {
                apiKeyAccountNumber: this.company.account[0].accNumber,
                env: 'prod'
            }, {root: true});
            if (this.company.companies.length > 0) this.$store.dispatch("wallets/getWallets", {
                groupCode: this.setting.apiKeys.apikeyCustomerID
                // customerId: this.company.accounts[0].accCustID
            }, {root: true})
            if (this.company.companies.length > 0) await this.$store.dispatch("wallets/readWallets", {
                customerId: this.setting.apiKeys.apikeyCustomerID
                // customerId: this.company.accounts[0].accCustID
            }, {root: true})
            if (this.company.companies.length > 0) this.$store.dispatch("logs/balanceEnquiry", {
                accountnumber: this.company.account[0].accNumber,
                env: 'prod'
            }, {root: true});
            if (this.company.companies.length > 0) {
                if (this.officerFilteredByUserId(this.system.userInfo.id)[0] != null)
                    if (
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL == null ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL == null
                    ) {
                        const options = {title: 'Warning!', size: 'sm'}
                        this.$dialogs.alert('Please complete your officer profile for this account', options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                this.$router.push('/officer-profile')
                            })
                    }
                this.$store.dispatch("wallets/readWalletTransactions", {
                    customerId: this.company.account[0].accCustID
                    // customerId: this.company.accounts[0].accCustID
                }, {root: true})
            }
        }
      }
    },
      created() {
          this.initDashboard()
      },
    mounted() {
      console.log(this.$route.path)
      console.log("new build")
      // $.plot()
      // this.readCompaniesNAccount()

      console.log(this.$ref ? 'Axios works!' : 'Uh oh..');
    },
  }
</script>



<style>
  @import "assets/lib/@fortawesome/fontawesome-free/css/all.min.css";
  @import "assets/lib/ionicons/css/ionicons.min.css";
  @import "assets/lib/jqvmap/jqvmap.min.css";
  @import "assets/css/dashforge.css";
  @import "assets/css/dashforge.dashboard.css";
  @import "assets/css/dashforge.contacts.css";
  @import "assets/lib/typicons.font/typicons.css";
  @import "assets/lib/prismjs/themes/prism-vs.css";
  @import "assets/lib/datatables.net-dt/css/jquery.dataTables.min.css";
  @import "assets/lib/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
  @import "assets/lib/select2/css/select2.min.css";
  @import "assets/css/dashforge.chat.css";
</style>

